import React, {memo, useEffect, useState, useCallback} from 'react';
import { Badge } from 'reactstrap';
import PrettyWaveform from 'components/waveform/PrettyWaveform.js';
import Colors from 'components/Colors.js';

window.samplerColor = '#545e6e';
const colors = new Colors();

export default memo(({sequencerEngine, selectedSampler, track, instrument, deleteSample, sample}) => {
    const [waveform, setWaveform] = useState('');

    const onClickNext = useCallback(() => {
        track.auditionNext();
    }, [track]);

    const onClickPrevious = useCallback(() => {
        track.auditionPrevious();
    }, [track]);

    useEffect(() => {
        if (selectedSampler && selectedSampler.baseBuffer && track.sample) {
            let color = colors.getColorForHash(selectedSampler.sample.getId());
            let newWaveform = (
                 <PrettyWaveform
                   instrument={instrument}
                   sequencerEngine={sequencerEngine}
                   store={sequencerEngine.store}
                    color={color}
                    div={document.getElementsByClassName('sampled-instrument')[0]}
                    track={track}
                    height={75}
                   backgroundColor={window.samplerColor}
                    fullWidth={false}
                    hideButtons={true}
                    selectedSlice={0}
                    slices={selectedSampler.slices}
                    isReversed={selectedSampler.isReversed()}
                    sampler={selectedSampler}
                    decentralized={true}
                    soundId={selectedSampler.sample.getId()}
                    onKeyDown={() => []}
                    onSelectSlice={() => []}
                    buffer={selectedSampler.baseBuffer.get()}/>
            );
            
            setWaveform(newWaveform);
        } else {
            setWaveform('');
        }
    }, [
        selectedSampler,
        setWaveform,
        track,
        instrument,
        track.sample]);

    let tags = (track.sample && track.sample.tags) || [];

    return (
        <div className="waveform-and-toolbar">
          <div className="waveform-toolbar">
            <div className="sample-name">
              {selectedSampler && selectedSampler.sample && selectedSampler.sample.name ?
               truncateName(selectedSampler.sample.name) : ''}
            </div>
            <div className="sample-chooser-buttons">
              <div
                onClick={onClickPrevious}
                className="previous-button"/>
              <div
                onClick={onClickNext}
                className="next-button"/>
            </div>
            {tags.map(tag => <Badge color={"light"}>{truncateName(tag)}</Badge>)}
            <div
              onClick={() => deleteSample(selectedSampler)}
              className="delete-button">x</div>
          </div>
          {waveform}
        </div>
    );
});

function truncateName(str) {
    return str.length >= 16 ? str.substring(0, 16) : str;
}
